import { Injectable } from '@angular/core';
import { NameMatchCriteria } from './name-match-criteria';
import { HttpClient } from '@angular/common/http';
import { PagedResponse } from '../../domain/response/PagedResponse';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class NameMatchSearchCtxService {
  public criteria = new NameMatchCriteria();
  public response: any = {
    searchResults: [],
    numberOfPages: 0,
  };

  constructor(private http: HttpClient, private router: Router) {}

  search() {
    this.findByCriteria(this.criteria).subscribe(
      (pagedResponse: PagedResponse) => {
        this.response = pagedResponse;
        this.response.numberOfPages = Math.ceil(
          pagedResponse.total / this.criteria.pageSize
        );
      }
    );
  }

  navigatePrevAvailable(fromId: number): boolean {
    const searchIdx = this.findSearchIdx(fromId);
    const available =
      searchIdx > -1 && (searchIdx > 0 || this.criteria.pageNumber > 1);
    return available;
  }

  navigateNextAvailable(fromId: number): boolean {
    const searchIdx = this.findSearchIdx(fromId);
    const available =
      searchIdx > -1 &&
      (searchIdx < this.response.searchResults.length - 1 ||
        this.criteria.pageNumber < this.response.numberOfPages);
    return available;
  }

  navigateByRow(direction: number, fromId: number) {
    const searchIdx = this.findSearchIdx(fromId);
    if (searchIdx > -1) {
      const nextIdx = searchIdx + direction;
      if (nextIdx < 0) {
        // previous page
        this.navigateByPage(-1);
      } else if (nextIdx >= this.response.searchResults.length) {
        // next page
        this.navigateByPage(+1);
      } else {
        const nextId = this.response.searchResults[nextIdx].speciesID;
        this.router.navigate(['/name-match-detail/' + nextId]);
      }
    }
  }

  findSearchIdx(speciesID: number): number {
    let searchIdx = -1;
    for (
      let nextIdx = 0;
      nextIdx < this.response.searchResults.length;
      nextIdx++
    ) {
      if (
        this.response.searchResults[nextIdx] &&
        this.response.searchResults[nextIdx].speciesID === speciesID
      ) {
        searchIdx = nextIdx;
        break;
      }
    }

    return searchIdx;
  }

  navigateByPage(direction: number) {
    const nextPageNumber = this.criteria.pageNumber + direction;
    if (nextPageNumber >= 1 && nextPageNumber <= this.response.numberOfPages) {
      this.criteria.pageNumber = nextPageNumber;
      this.findByCriteria(this.criteria).subscribe(
        (pagedResponse: PagedResponse) => {
          this.response = pagedResponse;
          this.response.numberOfPages = Math.ceil(
            pagedResponse.total / this.criteria.pageSize
          );

          const lastRowIdx = this.response.searchResults.length - 1;
          const lastRowId =
            this.response.searchResults[lastRowIdx].assessmentId;
          this.router.navigate(['/name-match-detail/' + lastRowId]);
        }
      );
    }
  }

  findByCriteria(criteria: NameMatchCriteria) {
    return this.http.post<PagedResponse>('/rest/match', criteria);
  }

  public clear() {
    this.criteria = new NameMatchCriteria();
  }
}
